import React from 'react';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { IWithWorksheetInjectedProps, WorksheetGridFieldSection, WorksheetRecordGrid } from '../../../../Core';
import { Field, NumericInput, Checkbox, TextOutput } from '../../../../../Core';
import deepEquals from '../../../../../../Lib/Object/deepEquals';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { getGridFieldSet as getMoistureContentGridFieldSet } from 'Components/Worksheets/MoistureContentWorksheet/Astm/gridFieldSets';
import { prefixRecordFieldSetNames } from 'Components/Worksheets/Core/WorksheetRecordGrid/helpers';
import { createDryMassEntryOptionSelector } from 'Components/Worksheets/MoistureContentWorksheet';

let LiquidLimitMethodBTrialSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const dryMassEntryOption = useSelector(createDryMassEntryOptionSelector(createWorksheetSelector!));
  const trialRecordProps = useSelector(
    pipe(createWorksheetSelector!('Trials'), valueOrDefault([] as Array<any>), (trials) =>
      trials.map((t, i) => ({
        dim: t.ExcludedTrial,
        preventRemove: i < 2,
      }))
    ),
    deepEquals
  );

  return (
    <WorksheetGridFieldSection name="Trials">
      <WorksheetRecordGrid
        name={'Trials'}
        orientation={'horizontal'}
        recordProps={{
          width: 130,
          preventRemove: (i) => trialRecordProps[i]?.preventRemove,
          dim: (i) => trialRecordProps[i]?.dim,
          enforceAtLeastOneRecord: true,
          removeConfirm: {
            confirm: true,
            confirmTitle: 'Trial Deletion',
            confirmText: 'Are you sure you want to delete the selected trial?',
            confirmButtonText: 'Delete Trial',
          },
        }}
        fieldSet={[
          {
            name: 'Drops',
            component: <Field input={<NumericInput />} />,
            label: 'Drops', // Remove when labels migrated to config
          },
          ...prefixRecordFieldSetNames('MoistureDetermination', getMoistureContentGridFieldSet(dryMassEntryOption)),
          {
            name: 'LiquidLimit',
            component: <Field input={<TextOutput />} />,
            label: 'Trial Liquid Limit', // Remove when labels migrated to config
          },
          {
            name: 'ExcludedTrial',
            component: <Field input={<Checkbox />} />,
            label: 'Exclude Trial', // Remove when labels migrated to config
          },
        ]}
      />
    </WorksheetGridFieldSection>
  );
};

LiquidLimitMethodBTrialSection = withInjectedProps(LiquidLimitMethodBTrialSection);

export { LiquidLimitMethodBTrialSection };
export default LiquidLimitMethodBTrialSection;
